export const tag = 'vehicleNotAvailablePageTemplate';
export const load = async () => {
    const { VehicleNotAvailablePageTemplateComponent } = await import(
        './vehicle-not-available-page-template.component'
    );
    return {
        component: VehicleNotAvailablePageTemplateComponent,
    };
};
